import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Fakturering = lazy(() => import("@/pages/mina-sidor/Fakturering"));

export const Route = createFileRoute("/mina-sidor/fakturering")({
  component: () => <Fakturering />,
});
